import { combineEpics } from 'redux-observable';


import jobs from './jobs/epic';
import jobEpic from './job/epic';
import search from './search/epic';
import remove from './actions/remove';

export default combineEpics(
  jobs,
  jobEpic, 
  search,
  remove
 
);
